import { render, staticRenderFns } from "./OrderDetailsHeader.vue?vue&type=template&id=d747b190&"
import script from "./OrderDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports